"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.valueToString = void 0;
const date_fns_1 = require("date-fns");
const chrono_1 = require("./chrono");
const value_1 = require("./value");
const visitor = {
    visitBoolean(value) {
        return value.value ? "true" : "false";
    },
    visitDate(value) {
        return (0, date_fns_1.format)((0, chrono_1.dateValueToDate)(value), "yyyy-MM-dd");
    },
    visitMonth(value) {
        return chrono_1.Month[value.value].toLowerCase();
    },
    visitNumber(value) {
        var _a, _b;
        return `${value.value}${(_b = (_a = value.unit) === null || _a === void 0 ? void 0 : _a.symbol) !== null && _b !== void 0 ? _b : ""}`;
    },
    visitQuote(value) {
        return value.quote.toSource();
    },
    visitRecord(value) {
        let result = "";
        let first = true;
        for (const [key, element] of value.elements) {
            if (first) {
                first = false;
            }
            else {
                result += ", ";
            }
            result += `${key}=${(0, exports.valueToString)(element)}`;
        }
        return result;
    },
    visitString(value) {
        return value.value;
    },
    visitTime(value) {
        return (0, date_fns_1.format)((0, chrono_1.timeValueToDate)(value), "HH:mm:ss");
    },
    visitVector(value) {
        return value.elements.map(exports.valueToString).join(", ");
    },
    visitWeekday(value) {
        return chrono_1.Weekday[value.value].toLowerCase();
    },
};
const valueToString = (value) => (0, value_1.visitValue)(visitor, value, undefined);
exports.valueToString = valueToString;
